import $ from 'jquery'

var $win = $(window),
	$body = $('body');

/**
 * modal
 */
var modal = function() {
	var $trigger = $('[data-modal="trigger"]'),
		$target = $('[data-modal="target"]');

	var Modal = (function() {

		function Modal(config) {
			this.$trigger = config.$trigger;
			this.key = config.key;
			this.$target = $target.filter('[data-modal-key="' + this.key + '"]');
			this.$scroll = this.$target.find('[data-modal="scroll"]');
			this.$close = this.$target.find('[data-modal="close"]');
		}

		Modal.prototype.init = function() {
			var _self = this;

			this.$trigger.on('click', function() {
				_self.showModal();
			});

			this.$close.on('click', function() {
				_self.hideModal();
			});
		};

		Modal.prototype.showModal = function() {
			var _self = this,
				touchStartY = 0;

			this.$target.fadeIn();
			$body.addClass('is-modal');

			$win.on('touchstart', function(e) {
				touchStartY = e.originalEvent.touches[0].clientY;
			});

			$win.on('touchmove.noScroll', function(event) {
				var currentY = event.originalEvent.touches[0].clientY,
					height = _self.$scroll.outerHeight(),
					isTop = touchStartY <= currentY && _self.$scroll[0].scrollTop === 0,
					isBottom = touchStartY >= currentY && _self.$scroll[0].scrollHeight - _self.$scroll[0].scrollTop === height;

				// スクロール対応モーダルの上端または下端のとき
				if (isTop || isBottom) {
					// スクロール禁止
					event.preventDefault();
				}
			});

			$win.on('modalChangeArea', function() {
				_self.$scroll.scrollTop(0);
			});
		};

		Modal.prototype.hideModal = function() {
			this.$target.fadeOut();
			$body.removeClass('is-modal');
			$win.off('.noScroll');
		};

		return Modal;
	})();

	$trigger.each(function() {
		new Modal({
			$trigger: $(this),
			key: $trigger.data('modalKey')
		}).init();
	});
};

// 職種のモーダル
var jobModal = function() {
	var $triggerJob = $('[data-modal="trigger_job"]'),
		$targetJob = $('[data-modal="target_job"]');

	var JobModal = (function() {

		function JobModal(config) {
			this.$triggerJob = config.$triggerJob;
			this.key = config.key;
			this.$targetJob = $targetJob.filter('[data-modal-key="' + this.key + '"]');
			this.$scroll = this.$targetJob.find('[data-modal="scroll"]');
			this.$close = this.$targetJob.find('[data-modal="close"]');
		}

		JobModal.prototype.init = function() {
			var _self = this;

			this.$triggerJob.on('click', function() {
				_self.showJobModal();
			});

			this.$close.on('click', function() {
				_self.hideJobModal();
			});
		};

		JobModal.prototype.showJobModal = function() {
			var _self = this,
				touchStartY = 0;

			this.$targetJob.fadeIn();
			$body.addClass('is-modal');

			$win.on('touchstart', function(e) {
				touchStartY = e.originalEvent.touches[0].clientY;
			});

			$win.on('touchmove.noScroll', function(event) {
				var currentY = event.originalEvent.touches[0].clientY,
					height = _self.$scroll.outerHeight(),
					isTop = touchStartY <= currentY && _self.$scroll[0].scrollTop === 0,
					isBottom = touchStartY >= currentY && _self.$scroll[0].scrollHeight - _self.$scroll[0].scrollTop === height;

				// スクロール対応モーダルの上端または下端のとき
				if (isTop || isBottom) {
					// スクロール禁止
					event.preventDefault();
				}
			});

			$win.on('modalChangeJob', function() {
				_self.$scroll.scrollTop(0);
			});
		};

		JobModal.prototype.hideJobModal = function() {
			this.$targetJob.fadeOut();
			$body.removeClass('is-modal');
			$win.off('.noScroll');
		};

		return JobModal;
	})();

	$triggerJob.each(function() {
		new JobModal({
			$triggerJob: $(this),
			key: $triggerJob.data('modalKey')
		}).init();
	});
};

/**
 * changeArea
 */
var changeArea = function() {
	var HIDE_CLASS = 'is-hide',
		DISABLED_CLASS = 'is-disabled';

	var $btnToCity = $('[data-area-to="city"]'),
		$btnToPrefecture = $('[data-area-to="prefecture"]'),
		$areaPrefecture = $('[data-area="prefecture"]'),
		$areaCity = $('[data-area="city"]');

	var checkChecked = function() {
		if ($areaPrefecture.find(':checked').length) {
			$btnToCity.removeClass(DISABLED_CLASS);
		} else {
			$btnToCity.addClass(DISABLED_CLASS);
		}
	};

	// click
	$btnToCity.on('click', function() {
		$areaCity.removeClass(HIDE_CLASS);
		$areaPrefecture.addClass(HIDE_CLASS);
		$btnToCity.addClass(HIDE_CLASS);
		$btnToPrefecture.removeClass(HIDE_CLASS);

		$win.trigger('modalChangeArea');
	});

	// click
	$btnToPrefecture.on('click', function() {
		$areaCity.addClass(HIDE_CLASS);
		$areaPrefecture.removeClass(HIDE_CLASS);
		$btnToCity.removeClass(HIDE_CLASS);
		$btnToPrefecture.addClass(HIDE_CLASS);

		$win.trigger('modalChangeArea');
	});

	// change
	$areaPrefecture.find(':checkbox').on('change', function() {
		checkChecked();
	});

	// run
	checkChecked();
};


/**
 * accordion
 */
var accordion = function() {
	$('#accordion').on('toggle', function(event) {
		if(event.target.open) {
			$('.summary-text').text('検索条件（エリア・キーワード）を隠す');
		} else {
			$('.summary-text').text('検索条件（エリア・キーワード）を表示');
		}
	})
};

/**
 * 検索パネルの初期化（モーダル・エリア切替・アコーディオン）
 * Vueマウント後に呼び出すためにexport
 */
export function initSearchPanel() {
	modal();
	changeArea();
	jobModal();
	accordion();
}

/**
 * Vue未使用ページでは従来通り自動初期化
 * #searchPanelApp がある場合はVue側で初期化するためスキップ
 */
$(function() {
	if (document.getElementById('searchPanelApp')) return
	initSearchPanel();
});
